import UAParser from 'ua-parser-js';
import { browsers } from '@/utils/constants';

export default {
  namespaced: true,
  state() {
    return {
      userAgentInfo: {}
    };
  },
  getters: {
    browserName: state => {
      const browserName = state.userAgentInfo?.browser.name;
      if (browserName.includes('Safari')) {
        return 'safari';
      }
      return browserName.toLowerCase();
    },
    isSafariBrowser: state => {
      return state.userAgentInfo?.browser.name.includes('Safari');
    },
    isFirefoxBrowser: state => {
      return state.userAgentInfo?.browser.name === 'Firefox';
    },
    isChromeBrowser: state => {
      return state.userAgentInfo?.browser.name === 'Chrome';
    },
    isMobileDevice: state => {
      return state.userAgentInfo?.device.type === 'mobile'
    },
    isMobileDeviceAndNotInAllowedList: state => {
      const deviceType = state.userAgentInfo?.device.type;
      const browserName = state.userAgentInfo?.browser.name;
      const allowedList = [browsers.chrome, browsers.edge, browsers.safari, browsers.mobileSafari];

      return ((!allowedList.includes(browserName)) && (deviceType === 'mobile'))
    },
    isMobileAndroid: state => {
      const deviceType = state.userAgentInfo?.device.type;
      const osName = state.userAgentInfo?.os.name;
      return ((osName === 'Android') && (deviceType === 'mobile'));
    },
    isMacOS: state => {
      return state.userAgentInfo?.os.name.includes('Mac');
    },
    // This check is needed to apply workaround on issue with iOS v18.4 or the frequent refreshing of the device list
    isIOS18_4: state => {
      const os =  state.userAgentInfo?.os;
      if (os.name !== 'iOS') return false;

      const version = os.version;
      const versionParts = version.split('.').map(Number);

      const major = versionParts[0] || 0;
      const minor = versionParts[1] || 0;

      return major === 18 && minor >= 4;
    },
    isIOS: state => {
      const os = state.userAgentInfo?.os;
      return os?.name === 'iOS';
    }
  },
  mutations: {
    setUserAgentInfo(state, userAgentInfo) {
      state.userAgentInfo = userAgentInfo;
    }
  },
  actions: {
    getUserAgentInfo({ commit }) {
      const parser = new UAParser().getResult();
      commit('setUserAgentInfo', parser);
    }
  }
};
